import { StorageService } from './../../services/storage.service';
import { AlertService } from './../../services/alert/alert.service';
import { HttpClient } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CancelProductComponent } from '../cancel-product/cancel-product.component';
import { PinResponse } from '../../models/pin.model';
import { PosStorageKey } from '../../services/storage.key';

@Component({
  selector: 'app-pin',
  templateUrl: './pin.component.html',
  styleUrls: ['./pin.component.scss'],
})
export class PinComponent implements OnInit, OnDestroy, AfterViewInit {
  dialogForm: FormGroup;
  subscriptions: Subscription[] = [];
  showErrorText = false;
  errorText = '';
  constructor(
    public dialogRef: MatDialogRef<PinComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private http: HttpClient,
    private alertService: AlertService,
    private storageService: StorageService
  ) {}
  ngAfterViewInit(): void {
    this.setFocus();
  }

  ngOnInit(): void {
    this.initForm();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  setFocus(): void {
    const firstLetter = document.getElementById('position_1');
    if (firstLetter) {
      firstLetter.focus();
    }
  }

  initForm(): void {
    this.dialogForm = this.fb.group({
      position_1: ['', [Validators.required]],
      position_2: ['', [Validators.required]],
      position_3: ['', [Validators.required]],
      position_4: ['', [Validators.required]],
    });

    this.subscriptions.push(
      this.dialogForm.controls.position_1.valueChanges.subscribe((change) => {
        if (!change) {
          return;
        }
        this.showErrorText = false;
        const lastLetter = change.split('').at(-1);
        if (lastLetter) {
          this.dialogForm.patchValue(
            {
              position_1: lastLetter,
            },
            { emitEvent: false }
          );
          const next = document.getElementById('position_2');
          if (next) {
            next.focus();
          }
        }
      })
    );
    this.subscriptions.push(
      this.dialogForm.controls.position_2.valueChanges.subscribe((change) => {
        if (!change) {
          return;
        }
        this.showErrorText = false;
        const lastLetter = change.split('').at(-1);
        if (lastLetter) {
          this.dialogForm.patchValue(
            {
              position_2: lastLetter,
            },
            { emitEvent: false }
          );
          const next = document.getElementById('position_3');
          if (next) {
            next.focus();
          }
        }
      })
    );
    this.subscriptions.push(
      this.dialogForm.controls.position_3.valueChanges.subscribe((change) => {
        if (!change) {
          return;
        }
        this.showErrorText = false;
        const lastLetter = change.split('').at(-1);
        if (lastLetter) {
          this.dialogForm.patchValue(
            {
              position_3: lastLetter,
            },
            { emitEvent: false }
          );
          const next = document.getElementById('position_4');
          if (next) {
            next.focus();
          }
        }
      })
    );
    this.subscriptions.push(
      this.dialogForm.controls.position_4.valueChanges.subscribe((change) => {
        if (!change) {
          return;
        }
        this.showErrorText = false;
        const lastLetter = change.split('').at(-1);
        if (lastLetter) {
          this.dialogForm.patchValue(
            {
              position_4: lastLetter,
            },
            { emitEvent: false }
          );
        }
      })
    );
  }

  async forgotPin(): Promise<void> {
    const confirm = await this.alertService.openConfirmDialog(`คุณต้องการกู้คืนรหัส PIN ใช่หรือไม่?`);

    if (!confirm) return;

    this.alertService.openDefaultDialog({
      title: 'กู้คืนรหัส PIN|ระบบจะส่งลิ้งค์กู้คืนรหัส PIN|ไปยังอีเมลของท่าน กรุณาตรวจสอบ',
      icon: 'mail',
    });

    const auth = this.storageService.get(PosStorageKey.auth);
    const user = auth.user;
    const location = window.location;
    const link = `${location.origin}/pin-recovery?token=${auth.access_token}`;
    const payload = {
      user: {
        firstname: user.first_name,
        lastname: user.last_name,
      },
      email: user.email,
      link,
    };

    this.dialogRef.close(false);
    this.http.post('users/recovery_pin', payload).subscribe((result) => {});
  }

  close(): void {
    this.dialogRef.close(false);
  }

  async onSubmit(): Promise<void> {
    this.showErrorText = false;
    if (this.dialogForm.invalid) {
      return;
    }
    const extractLetter = [];
    for (const key in this.dialogForm.value) {
      if (Object.prototype.hasOwnProperty.call(this.dialogForm.value, key)) {
        const element = this.dialogForm.value[key];
        extractLetter.push(element);
      }
    }
    const mergeLetter = extractLetter.join('');

    if (this.data.mode === 'grant_permission') {
      this.dialogRef.close(mergeLetter);
      return;
    }

    const checkPin = await this.http.post<PinResponse>('users/verify_pin', { pin: mergeLetter }).toPromise();
    if (!checkPin.success) {
      this.dialogForm.reset();
      const target = document.getElementById('position_1');
      if (target) {
        target.focus();
      }

      this.showErrorText = true;
      switch (checkPin.code) {
        case 1:
          this.errorText = 'คุณไม่มีสิทธิ์เข้าใช้งานในส่วนนี้';
          break;
        case 2:
          this.errorText = 'รหัส PIN ไม่ถูกต้อง';
          break;
        default:
          this.errorText = 'รหัส PIN ไม่ถูกต้อง';
          break;
      }
      return;
    }

    if (this.data.mode === 'cancel_product') {
      this.openCancelProductDialog(1);
    }

    if (this.data.mode === 'cancel_bill') {
      this.openCancelProductDialog(2);
    }

    if (this.data.mode === 'edit_product') {
      this.dialogRef.close(true);
    }

    if (this.data.mode === 'close_payment') {
      this.dialogRef.close(true);
    }

    // this.dialogRef.close(false);
  }

  openCancelProductDialog(mode: number): void {
    const dialog = this.dialog.open(CancelProductComponent, {
      width: '450px',
      maxWidth: '90vw',
      maxHeight: '90vh',
      disableClose: true,
      data: { ...this.data, mode },
    });

    dialog.afterClosed().subscribe((result) => {
      if (result) {
        this.dialogRef.close(result);
      } else {
        this.dialogRef.close(false);
      }
    });
  }

  selectAllOnClick(element) {
    console.log('selcet', element);

    if (element) {
      const target = document.getElementById(element.id) as HTMLInputElement;
      if (target) {
        target.setSelectionRange(0, target.value.length);
      }
    }
  }

  resetPinInput() {
    this.dialogForm.reset();
  }
}
